<div class="container timeline-container timeline-theme-1">
    <div>
        <ul class="timeline_list">
            <li class="timeline_link" *ngFor="let yl of yearsList;let i = index">
                <span class="hp" [ngClass]="{'active': na === i}" (click)="nActive(i, yl.taxonomyId)">{{yl.taxonomyTitle}}</span>
            </li>
        </ul>
    </div>
    <div>
        <div class="container mt-5">
            <div class="row">
                <div class="col-6 col-sm-6 col-md-4 col-xl-2dot4 book media position-relative pl-0 mb-5" *ngFor="let al of authorList">
                    <img alt="" class="shadow mr-3 rounded-lg" style="height: 100%; width: 145px;" src="{{url + al.figure}}">
                    <div class="media-body mgl">
                        <h5 class="m-0 fgq f18">{{al.authorName}}</h5>
                        <a class="stretched-link" href="/author/{{al.authorId}}"></a>
                    </div>
                </div>
            </div>
            <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center">
                    <nz-pagination [(nzPageIndex)]="page" [nzPageSize]="pageSize" [nzTotal]="total" (nzPageIndexChange)="GetAuthorList(navId, page, pageSize)" nzSimple></nz-pagination>
                </ul>
            </nav>
        </div>
    </div>
</div>